import { action } from 'satcheljs/lib/legacy';
export default action('setIsSavingSpinnerShown')(function setIsSavingSpinnerShown(viewState, isShown) {
    viewState.isSavingSpinnerShown = isShown;
});
//# sourceMappingURL=setIsSavingSpinnerShown.js.map